<template>
  <div :class="{ 'weather-remind': true, 'remind_light': theme === 'light' }">
    <div class="header">
      <span v-for="item in tableHeader" :key="item">{{ item }}</span>
    </div>
    <div class="body-content" ref="riskRef" @mouseover="mouseover" @mouseout="mouseout">
      <div class="body-item" v-for="item, index in tableData" :key="index">
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content" style="width: 20.25vw;line-height: 1.56vw;">{{ item.cont }}</div>
          <div class="body-item">
            <span>{{ $moment(item.crttimeFmt).format('MM-DD HH:mm') }}</span>
            <span>{{ item.objname }}</span>
            <span>{{ item.cont }}</span>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { apiData } from '@/api'
export default {
  props: {
    theme: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      tableHeader: ['发布时间', '项目名称', '消息内容'],
      tableData: [],
      timmer: null
    }
  },
  created() {
    this.newTxMsgShiWu()
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        const riskRef = this.$refs.riskRef
        const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
        if (scrollHeight > 0) {
          this.startTimmer(riskRef, scrollHeight)
        }
      })
    }, 2000)
  },
  methods: {

    async newTxMsgShiWu() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.newTxMsgShiWu(unit.id)
      this.tableData = result.data
    },

    startTimmer(riskRef, scrollHeight) {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
      this.timmer = setInterval(() => {
        riskRef.scrollTo({
          top: riskRef.scrollTop + 1
        })
        if (riskRef.scrollTop > (scrollHeight - 2)) {
          clearInterval(this.timmer)
          setTimeout(() => {
            riskRef.scrollTo({
              top: 0
            })
            setTimeout(() => {
              this.startTimmer(riskRef, scrollHeight)
            }, 2000)
          }, 2000)
        }
      }, 15)
    },

    mouseover() {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
    },
    mouseout() {
      const riskRef = this.$refs.riskRef
      const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
      if (scrollHeight > 0) {
        this.startTimmer(riskRef, scrollHeight)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.weather-remind {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  padding-top: 0.63vw;
  margin-bottom: 0.63vw;
  padding: 0.63vw 1.09vw 0 0;

  .header {
    display: flex;
    align-items: center;
    height: 2.71vw;
    margin-left: 1.11vw;
    background: #244274;
    border-radius: 0.21vw;

    // span:nth-child(1) {
    //   display: inline-block;
    //   width: 70px;
    // }
    // span:nth-child(2) {
    //   flex: 1;
    // }
    span {
      flex: 1;
      text-align: center;
      font-size: 0.73vw;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 1.04vw;
    }
  }

  .body-content {
    flex: 1;
    padding-bottom: 3px;
    overflow: hidden;
    overflow-y: auto;

    .body-item {
      display: flex;
      align-items: center;
      height: 2.71vw;

      span {
        flex: 1;
        padding: 0vw 0.52vw;
        text-align: center;
        font-size: 0.73vw;
        color: #FFFFFF;
        line-height: 1.04vw;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0.52vw;
}

::-webkit-scrollbar-track {
  background: #E7E7E7;
  border-radius: 1.09vw;
}

::-webkit-scrollbar-thumb {
  background: #D8D8D8;
  border-radius: 1.09vw;
  height: 1.56vw;
}

.body-content::-webkit-scrollbar-track {
  background: #0C355F;
}

.body-content::-webkit-scrollbar-thumb {
  background: #2F557A;
}

.remind_light {
  .header {
    background: #ECF0F7;

    span {
      color: #333333;
    }
  }

  .body-content {
    .body-item {
      span {
        color: #333333;
      }
    }
  }

  .body-content::-webkit-scrollbar-track {
    background: #E7E7E7;
  }

  .body-content::-webkit-scrollbar-thumb {
    background: #D8D8D8;
  }
}
</style>
